import React from "react";
import { Chip } from "@mui/material";
import { StatusOptions, StatusOptionsDocuments } from "../../../types/FilterEnums";
import { statusCellStyle } from "../style";
import { useTranslation } from "react-i18next";
interface StatusCellRendererProps {
  value: StatusOptions | StatusOptionsDocuments;
}

const StatusCellRenderer: React.FC<StatusCellRendererProps> = ({ value }) => {
  const getColor = (status: StatusOptions | StatusOptionsDocuments) => {
    switch (status) {
      case StatusOptions.ASSIGNED:
        return "#5AA1F3";
      case StatusOptions.ALLOCATED:
        return "#3987E2";
      case StatusOptions.IN_PROGRESS:
        return "#146ED7";
      case StatusOptions.WAITING_FOR_DOCUMENTATION:
        return "#002756";
      case StatusOptions.COMPLETED:
        return "#125097";
        case StatusOptionsDocuments.PROFILO_PARZIALE:
          return "#FFC107";
      default:
        return "default";
    }
  };

  const {t} = useTranslation();

  const statusDisplayNames: Record<StatusOptions, string> = {
    [StatusOptions.ASSIGNED]:  t('screens.trips.statusOptions.ASSIGNED'),
    [StatusOptions.ALLOCATED]: t('screens.trips.statusOptions.ALLOCATED'),
    [StatusOptions.IN_PROGRESS]: t('screens.trips.statusOptions.IN_PROGRESS'),
    [StatusOptions.WAITING_FOR_DOCUMENTATION]: t('screens.trips.statusOptions.WAITING_FOR_DOCUMENTATION'),
    [StatusOptions.COMPLETED]:t('screens.trips.statusOptions.COMPLETED'),
  };
  const displayName =
  statusDisplayNames[value as StatusOptions] || value;



  return (
    <Chip
      label={value==="Profilo Parziale"?"To be evaluated":displayName}
      sx={{
        backgroundColor: getColor(value),
        ...statusCellStyle.chip,
      }}
      variant="filled"
    />
  );
};

export default StatusCellRenderer;
